import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { CountryService } from '../Admin/Countries/services/EquipmentCountry';

interface RouteParams {
  searchLabelType: string;
  countryCode: string;
  search_adresse: string;
  rooms?: string;
  click?: string;
  eqt?: string;
  price?: string;
  qid?: string;
  quartier?: string;
  priceMin?: string;
}

const countryMap: { [key: string]: string } = {
  cm: 'Cameroon',
  ga: 'Gabon',
  sn: 'Senegal',
  td: 'Chad',
  cg: 'Congo+Republic',
  ci: 'Cote+d%27Ivoire',
  ml: 'Mali',
  tg: 'Togo',
  bj: 'Benin',
  ma: 'Morocco',
  tn: 'Tunisia',
  bf: 'Burkina Faso',
  mr: 'Mauritania',
  mu: 'Mauritius',
  fr: 'France',
  ng: 'Nigeria',
  gh: 'Ghana',
  cf: 'Central Africa Republic',
  gq: 'Equatorial Guinea',
};

const searchTypeMap: { [key: string]: string } = {
  logements: 'apts',
  hotels: 'htls',
  voitures: 'cars',
  immobilier: 'rstt',
  circuits: 'trs',
  evenements: 'evts',
};


const countryService = new CountryService();

export const ShortlinkStay: React.FC = () => {
  const { searchLabelType, countryCode, search_adresse, rooms, click, eqt, price, qid, quartier, priceMin } = useParams<RouteParams>();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const countryName = countryMap[countryCode.toLowerCase()];
        if (!countryName) {
          console.error(`Invalid country code: ${countryCode}`);
          setIsLoading(false);
          return;
        }

        const countryResponse = await countryService.getCountryByName(countryName);
        if (!countryResponse?.data) {
          console.error(`Country with name ${countryName} not found.`);
          setIsLoading(false);
          return;
        }

        const { _id: countryId, currencyCode } = countryResponse.data;

        const cityResponse = await countryService.getCityByName(search_adresse);
        if (!cityResponse?.data) {
          console.error(`City with name ${search_adresse} not found.`);
          setIsLoading(false);
          return;
        }

        const { _id: cityId } = cityResponse.data;
        const type = searchTypeMap[searchLabelType] || '';

        const queryParams = new URLSearchParams({
          search_pays: countryId,
          search_adresse: cityId,
          quartier: quartier || '',
          offer: '0',
          currencyBase: currencyCode,
          refreshData: '1',
          currency: currencyCode,
          travellerChildTotal: '0',
          travellerAdultTotal: '2',
          click: click || '',
          rooms: rooms || '',
          eqt: eqt || '',
          price: price || '0',
          priceMin: priceMin || '0',
          page: '1',
          luxury: 'false',
          perle: 'false',
          business: 'false',
          type,
        });

        if (qid) {
          queryParams.set('qid', qid);
        }

        history.replace(`/search?${queryParams.toString()}`);
      } catch (error) {
        if (error instanceof Error) {
          console.error('Error fetching data:', error.message);
        } else {
          console.error('Unknown error occurred:', error);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [searchLabelType, countryCode, search_adresse, quartier, rooms, click, eqt, price, priceMin, qid, history]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return null;
};
